var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-width":"550px","margin":"0 auto","position":"relative"},attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.authLoading),expression:"!authLoading"}]},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }